import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { HttpClientService } from './http-client.service';

@Injectable({
  providedIn: 'root'
})
export class InscricoesTributariasService {

  urlApi = environment.api;
  token = sessionStorage.getItem('loginAuth');

  constructor(private http: HttpClientService) { }

  getCCM(numeroProtocolo: any): Promise<any> {
    return this.http.get( this.urlApi + '/ccm/' + numeroProtocolo)
    .toPromise()
    .then(response => response);
  }

  putCCM(numeroProtocolo: any, body){
    return this.http.put( this.urlApi + '/ccm/' + numeroProtocolo, body)
    .toPromise()
    .then(response => response);
  }

}
